const env = window.AppENV || {};

const initialState = {
  ...env,
  appConf: window.appConf || {}
};

function serviceConfigs(state = initialState, action) {
  switch (action.type) {
    // Example: Handling an action to update a config
    case 'UPDATE_SERVICE_CONFIG':
      return state.setIn(['appConf', action.key], action.value);
    // Add other action handling logic here
    default:
      return state;
  }
}

export default serviceConfigs;
